
























































































import Vue from "vue";
import { createNamespacedHelpers } from "vuex";
import moment from "moment-timezone";
import ReportDateFilter from "./ReportDateFilter.vue";

interface ClientReport {
  report_name: string;
  value: number;
  count?: number;
}

const { mapActions: reportsActions, mapGetters: reportsGetters } =
  createNamespacedHelpers("reports");

const tz = localStorage.getItem("tz") ?? "Africa/Nairobi";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default Vue.extend<any, any, any, any>({
  name: "ClientReportList",
  components: {
    ReportDateFilter,
  },

  props: {
    cardView: {
      default: false,
    },
  },
  data: () => ({
    headers: [
      { text: "Type", value: "report_name", sortable: false },
      { text: "Value", value: "value", sortable: false },
      { text: "actions", value: "actions", sortable: false },
    ],
    startDate: null,
    endDate: null,
    applyDateFilter: true,
    filterStart: null,
    filterEnd: null,
    params: {},
  }),
  computed: {
    ...reportsGetters(["clientReports", "loading", "error"]),
    reports(): ClientReport[] {
      return this.clientReports || [];
    },
  },
  methods: {
    ...reportsActions(["fetchClientReports"]),
    getParams() {
      const queryString = window.location.search;
      const params = new URLSearchParams(queryString);
      this.params = {
        method: params.get("method"),
        startDate: params.get("startDate"),
        endDate: params.get("endDate"),
        type: params.get("type"),
      };
    },
    onRangeChange(filters) {
      this.filterStart = filters.start;
      this.filterEnd = filters.end;

      if (this.applyDateFilter) {
        this.startDate = filters.start;
        this.endDate = filters.end;
      }
    },
    async fetchClientReportsData() {
      try {
        await this.fetchClientReports({
          startDate: this.startDate,
          endDate: this.endDate,
        });
      } catch (error) {
        console.error("Error fetching client reports:", error);
      }
    },
    formatDate(date: string) {
      if (!date) return null;

      return moment(date).tz(tz).format("DD/MM/YYYY");
    },
    clear() {
      this.startDate = null;
      this.endDate = null;
    },
    navigate(item: ClientReport) {
      const query: Record<string, string> = {
        tab: "orders",
        type: item.report_name.toLowerCase(),
      };
      if (this.startDate) {
        const date = new Date(this.startDate);
        date.setHours(0, 0, 0, 0);
        query.startDate = date.toISOString();
      }
      if (this.endDate) {
        const date = new Date(this.endDate);
        date.setHours(23, 59, 59, 59);
        query.endDate = date.toISOString();
      }

      if (item.report_name.toLowerCase().includes("ratings")) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (this as any).$router.push({
          path: "/reports/client-report-detail",
          query,
        });
      }

      if (
        item.report_name.toLowerCase().includes("return") ||
        item.report_name.toLowerCase().includes("new clients") ||
        item.report_name.toLowerCase().includes("all clients")
      ) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (this as any).$router.push({
          path: "/reports/new-client-report-detail",
          query,
        });
      }

      if (item.report_name.toLowerCase() === "most sold service") {
        query.type = "amount";
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (this as any).$router.push({
          path: "/reports/top-service-report-detail",
          query,
        });
      }
      if (item.report_name.toLowerCase() === "most sold service by quantity") {
        query.type = "quantity";
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (this as any).$router.push({
          path: "/reports/top-service-report-detail",
          query,
        });
      }
    },
    toggle() {
      // toggle implementation
    },
    getClientReportIcon(reportName: string): string {
      const iconMap: Record<string, string> = {
        "All Clients": "mdi-account-group",
        "New Clients": "mdi-account-plus",
        "Return Clients": "mdi-account-arrow-left",
        "Client Ratings": "mdi-star-circle",
        "Most Sold Service": "mdi-trending-up",
        "Most Sold Service by Quantity": "mdi-counter",
      };
      return iconMap[reportName] || "mdi-account-circle";
    },
    getClientReportIconColor(reportName: string): string {
      const colorMap: Record<string, string> = {
        "All Clients": "primary",
        "New Clients": "green",
        "Return Clients": "blue",
        "Client Ratings": "orange",
        "Most Sold Service": "purple",
        "Most Sold Service by Quantity": "teal",
      };
      return colorMap[reportName] || "grey";
    },
    getValueChipColor(value: number): string {
      if (value >= 1000) return "green";
      if (value >= 500) return "blue";
      if (value >= 100) return "orange";
      return "grey";
    },
    formatValue(item: ClientReport): string {
      // Format based on report type
      if (item.report_name.includes("Rating")) {
        return `${item.value}/5 ⭐`;
      }
      if (item.report_name.includes("Quantity")) {
        return `${item.value} items`;
      }
      if (item.report_name.includes("Service")) {
        return `${item.value} services`;
      }
      return item.value.toString();
    },
  },
  watch: {
    applyDateFilter(x) {
      if (!x) {
        this.startDate = null;
        this.endDate = null;
      } else {
        this.startDate = this.filterStart;
        this.endDate = this.filterEnd;
      }
    },
    startDate() {
      this.fetchClientReportsData();
    },
    endDate() {
      this.fetchClientReportsData();
    },
  },
  mounted() {
    console.log("mounted");
    this.getParams();
    this.fetchClientReportsData();
  },
});
